import type { Ssm5FreezeFrameParameter } from '@packages/domain/ssm5';

/** The number of PIDs on a page unless the technician chooses another size. */
export const DEFAULT_FREEZE_FRAME_PAGE_SIZE = 50;

/** The PIDs of one page and their positions among all results. */
export type Ssm5FreezeFramePage = {
    /** The first row's position, counted from 1, or 0 without rows. */
    first: number;
    /** The last row's position, counted from 1, or 0 without rows. */
    last: number;
    /** The PIDs of the page. */
    rows: Ssm5FreezeFrameParameter[];
    /** The number of PIDs on all pages. */
    total: number;
};

/**
 * Select the rows of a page and count their positions from 1.
 *
 * @param parameters - all matching PIDs
 * @param pageIndex - the page index, counted from 0
 * @param pageSize - the number of rows per page
 * @returns the page and its result positions
 */
export function freezeFramePage(
    parameters: readonly Ssm5FreezeFrameParameter[],
    pageIndex: number,
    pageSize: number
): Ssm5FreezeFramePage {
    const offset = pageIndex * pageSize;
    const rows = parameters.slice(offset, offset + pageSize);
    const hasRows = rows.length > 0;

    return {
        first: hasRows ? offset + 1 : 0,
        last: hasRows ? offset + rows.length : 0,
        rows,
        total: parameters.length,
    };
}
